import React from 'react';
import URL from '../domain/URL';
import { t, props } from 'tcomb-react';

@props({
  url: URL,
  label: t.Str
})
export default class PurchasePaymentUrl extends React.Component {

  render() {
    return (
      <a target='_top' href={this.props.url}>{this.props.label}</a>
    );
  }

}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/PurchasePaymentUrl.js
 **/